import React, { Fragment, useEffect, useState } from "react";
import { formatMoney } from "../../../../helpers/formatter";
import { useWalletDetailsByWalletId } from "../../../../custom-hooks/useWallet";
import { MixPanel } from "../../../../shared/MixPanel/MixPanel";

const ApproveWithdrawalRequests = ({ properties, onCloseModal }) => {
  const {
    reference,
    handleSubmit,
    loading,
    handleDecline,
    amount,
    currencyCode,
    wallet_id,
    funder_id,
    account_number,
    account_name,
    bank_code,
  } = properties;
  const [otp, setOtp] = useState("");
  const [comment, setComment] = useState("");

  useEffect(() => {
    MixPanel.track(`Page View: ApproveWithdrawalRequests.tsx`, {
      page: "ApproveWithdrawalRequests.tsx",
    });
  }, []);

  const handleApprove = (e) => {
    e.preventDefault();
    handleSubmit({ reference: reference, comment: comment, otp: otp });
  };
  const handleReject = (e) => {
    e.preventDefault();
    handleDecline({ reference: reference, comment: comment });
  };

  const { data, status, error } = useWalletDetailsByWalletId(
    wallet_id,
    funder_id,
  );

  return (
    <div
      className="AuditTrailModal Modal__content"
      style={{ overflow: "hidden" }}
    >
      <div className="Modal__body">
        <Fragment>
          <h3 className="Modal__title p-b-1">Two Factor Authentication</h3>
          <hr />
          <form onSubmit={handleApprove}>
            <div className="row">
              {status !== "loading" && !data && (
                <p className="alert alert-danger col-md-6">
                  Error fetching wallet balance.. Please reload
                </p>
              )}
              <div className="col-12 mb-1">
                <label>Account Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="amount"
                  defaultValue={account_name}
                  readOnly
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Account Number</label>
                <input
                  type="text"
                  className="form-control"
                  name="amount"
                  defaultValue={account_number}
                  readOnly
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Bank Code</label>
                <input
                  type="text"
                  className="form-control"
                  name="amount"
                  defaultValue={bank_code}
                  readOnly
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Wallet Balance</label>
                {status === "loading" ? (
                  <p className="text-primary font-weight-bold">
                    Loading Wallet Details...
                  </p>
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    name="walletBalance"
                    defaultValue={formatMoney(
                      data?.availableBalance || 0,
                      data?.currencyCode || "",
                    )}
                    readOnly
                  ></input>
                )}
              </div>
              <div className="col-12 mb-1">
                <label>Withdrawal Amount</label>
                <input
                  type="text"
                  className="form-control"
                  name="amount"
                  defaultValue={formatMoney(amount, currencyCode)}
                  readOnly
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Generated 2FA</label>
                <input
                  type="text"
                  className="form-control"
                  name="otp"
                  defaultValue={otp}
                  onChange={(e) => setOtp(e.target.value)}
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Reference</label>
                <input
                  type="text"
                  className="form-control"
                  name="reference"
                  defaultValue={reference}
                  disabled
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Comment</label>
                <input
                  type="text"
                  className="form-control"
                  name="comment"
                  defaultValue={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></input>
              </div>
              <div className="col-12 d-flex justify-content-end flex-wrap">
                <button
                  className="btn advancly-dimred-btn btn-sm transition-3d-hover mt-2"
                  type="submit"
                  disabled={loading || !comment || !reference}
                  onClick={handleReject}
                >
                  Decline
                </button>
                <button
                  className="btn advancly-btn btn-sm transition-3d-hover mt-2"
                  type="submit"
                  disabled={loading || !comment || !otp || !reference}
                  onClick={handleApprove}
                >
                  Approve
                </button>
              </div>
            </div>
          </form>
        </Fragment>
      </div>
    </div>
  );
};
export default ApproveWithdrawalRequests;
